// extracted by mini-css-extract-plugin
module.exports = {"labelText":"LoginPageForm_labelText__32vqN","forgotPassword":"LoginPageForm_forgotPassword__3728z","logInBtn":"LoginPageForm_logInBtn__7ACP5"};